// src/pages/Home.jsx
import React from "react";

export default function Home({ lang = "hr" }) {
  const t = {
    hr: {
      title: "Somnia madraci",
      tagline: "Savršen san, svaki dan.",
      lead:
        "Somnia nudi premium madrace izrađene s pažnjom i vrhunskim materijalima. Naša kolekcija kombinira udobnost, potporu i dugotrajnost — dizajnirano i proizvedeno u Hrvatskoj.",
      ctaPrimary: "Pregledaj kolekciju",
      ctaGhost: "Zašto Somnia",
      usp1: "Ručna izrada",
      usp2: "140 kg/m³ pjene",
      usp3: "10 godina garancije",
      groups: ["ORIGINAL", "KLASIK", "GOLD"],
      craftTitle: "Ručna izrada u EU",
      craftBullets: [
        "Ručno završeni rubovi i precizno šivanje",
        "Odabir pjena za dugotrajnu elastičnost",
        "Kontrola kvalitete nakon svake faze",
        "Premium navlake i certificirani materijali",
      ],
      bestTitle: "Najprodavaniji",
      from: "od",
      btnDetails: "Detalji i kupnja",
      btnCompare: "Usporedi",
      quote:
        "Moj san je udobniji nego ikad — podupire tijelo i pruža luksuz svake noći.",
    },
    en: {
      title: "Somnia mattresses",
      tagline: "Perfect sleep, every day.",
      lead:
        "Somnia offers premium mattresses crafted with care and top-grade materials. Our collection blends comfort, support and durability — designed and made in Croatia.",
      ctaPrimary: "View collection",
      ctaGhost: "Why Somnia",
      usp1: "Handcrafted",
      usp2: "140 kg/m³ foams",
      usp3: "10-year warranty",
      groups: ["ORIGINAL", "CLASSIC", "GOLD"],
      craftTitle: "Handcrafted in the EU",
      craftBullets: [
        "Hand-finished edges and precise tape-edge",
        "Foam selection for long-term resilience",
        "Quality checks after each stage",
        "Premium covers & certified materials",
      ],
      bestTitle: "Bestsellers",
      from: "from",
      btnDetails: "Details & purchase",
      btnCompare: "Compare",
      quote:
        "Every night feels luxurious — unmatched comfort and support.",
    },
  }[lang];

  // slike (zamijeni vlastitima u /public/images)
  const heroPhoto =
    "https://images.unsplash.com/photo-1505691938895-1758d7feb511?q=80&w=1920&auto=format&fit=crop";
  const craftPhoto =
    "https://images.unsplash.com/photo-1560185008-b033106af2fb?q=80&w=1600&auto=format&fit=crop";
  const products = [
    {
      name: lang === "hr" ? "Madrac Original" : "Mattress Original",
      slug: "original",
      img:
        "https://images.unsplash.com/photo-1524758631624-e2822e304c36?q=80&w=1200&auto=format&fit=crop",
      price: "499 €",
    },
    {
      name: lang === "hr" ? "Madrac Klasik" : "Mattress Classic",
      slug: "klasik",
      img:
        "https://images.unsplash.com/photo-1560066984-138dadb4c035?q=80&w=1200&auto=format&fit=crop",
      price: "699 €",
    },
    {
      name: lang === "hr" ? "Madrac Gold" : "Mattress Gold",
      slug: "gold",
      img:
        "https://images.unsplash.com/photo-1540518614846-7eded433c457?q=80&w=1200&auto=format&fit=crop",
      price: "999 €",
    },
  ];

  const productsPath =
    lang === "hr" ? "/hr/proizvodi" : "/en/products";
  const productDetailPath = (slug) =>
    lang === "hr" ? `/hr/proizvod/${slug}` : `/en/product/${slug}`;

  return (
    <div className="bg-navy text-white">
      {/* HERO */}
      <section className="relative isolate">
        {/* pozadinska fotografija + tamni overlay */}
        <div
          className="absolute inset-0 -z-10 opacity-40"
          style={{
            backgroundImage: `url('${heroPhoto}')`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
        <div className="absolute inset-0 -z-10 bg-gradient-to-b from-navy/10 via-navy/60 to-navy" />

        <div className="max-w-6xl mx-auto px-6 py-16 md:py-24">
          <div className="flex items-start gap-6">
            {/* Logo krug */}
            <img
              src="/images/somnia-logo.png"
              alt="Somnia logo"
              className="hidden sm:block w-20 h-20 md:w-24 md:h-24 object-contain"
            />
            <div>
              <h1 className="text-gold text-4xl md:text-6xl font-semibold tracking-wide">
                {t.title}
              </h1>
              <p className="mt-3 text-xl font-semibold">{t.tagline}</p>
              <p className="mt-3 max-w-2xl text-gray-300">{t.lead}</p>

              <div className="mt-7 flex flex-wrap gap-3">
                <a
                  href={productsPath}
                  className="inline-flex h-11 items-center rounded-full bg-gold px-5 font-semibold text-black hover:bg-gold-dark transition"
                >
                  {t.ctaPrimary}
                </a>
                <a
                  href="#zasto"
                  className="inline-flex h-11 items-center rounded-full border border-white/20 px-5 font-semibold hover:border-gold hover:text-gold transition"
                >
                  {t.ctaGhost}
                </a>
              </div>

              {/* USPs */}
              <div className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-5">
                {[
                  t.usp1,
                  t.usp2,
                  t.usp3,
                ].map((txt) => (
                  <div
                    key={txt}
                    className="flex items-center gap-3 bg-white/5 border border-white/10 rounded-xl px-4 py-3"
                  >
                    <div className="w-10 h-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center">
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        className="text-gold"
                      >
                        <path
                          fill="currentColor"
                          d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
                        />
                      </svg>
                    </div>
                    <span className="text-gray-200">{txt}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* MODEL GRUPE */}
      <section id="models" className="py-10 md:py-14">
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {t.groups.map((label, i) => (
              <article
                key={label}
                className="rounded-2xl overflow-hidden border border-white/10 bg-white/5 hover:bg-white/[0.08] transition shadow-xl"
              >
                <div
                  className="h-44 sm:h-48 w-full bg-cover bg-center"
                  style={{
                    backgroundImage: `url('${products[i].img}')`,
                  }}
                />
                <div className="p-5">
                  <h3 className="text-center text-lg tracking-[0.25em] text-gold font-semibold">
                    {label}
                  </h3>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* RUČNA IZRADA / CRAFT */}
      <section id="zasto" className="py-8 md:py-12">
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-8 items-center">
          <div
            className="rounded-2xl overflow-hidden border border-white/10 shadow-2xl h-72 md:h-96 bg-cover bg-center"
            style={{ backgroundImage: `url('${craftPhoto}')` }}
            aria-label="Ručna izrada"
          />
          <div>
            <h2 className="text-2xl md:text-3xl text-gold font-semibold mb-4">
              {t.craftTitle}
            </h2>
            <ul className="space-y-3 text-gray-300">
              {t.craftBullets.map((b) => (
                <li key={b} className="flex gap-3">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    className="mt-1 text-gold"
                  >
                    <path
                      fill="currentColor"
                      d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
                    />
                  </svg>
                  <span>{b}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* NAJPRODAVANIJI */}
      <section className="py-10 md:py-14">
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="text-center text-2xl md:text-3xl font-semibold">
            {t.bestTitle}
          </h2>

          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            {products.map((p) => (
              <article
                key={p.slug}
                className="rounded-2xl border border-white/10 bg-white/5 shadow-xl overflow-hidden flex flex-col"
              >
                <img
                  src={p.img}
                  alt={p.name}
                  className="h-44 w-full object-cover"
                  loading="lazy"
                />
                <div className="p-5 flex-1 flex flex-col">
                  <h3 className="text-white font-semibold">{p.name}</h3>
                  <div className="mt-1 text-sm text-gray-400">
                    {t.from}{" "}
                    <span className="text-gold font-semibold">{p.price}</span>
                  </div>

                  <div className="mt-5 flex gap-3">
                    <a
                      className="inline-flex h-10 items-center rounded-full bg-gold px-4 font-semibold text-black hover:bg-gold-dark transition"
                      href={productDetailPath(p.slug)}
                    >
                      {t.btnDetails}
                    </a>
                    <a
                      className="inline-flex h-10 items-center rounded-full border border-white/20 px-4 font-semibold hover:border-gold hover:text-gold transition"
                      href={productsPath}
                    >
                      {t.btnCompare}
                    </a>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* TESTIMONIAL */}
      <section className="py-10">
        <div className="max-w-4xl mx-auto px-6">
          <blockquote className="relative rounded-2xl border border-white/10 bg-white/5 p-8 md:p-10 text-lg text-gray-200">
            <span className="absolute -top-5 left-6 text-gold text-6xl leading-none select-none">“</span>
            <p className="pl-8">{t.quote}</p>
          </blockquote>
        </div>
      </section>
    </div>
  );
}
